import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Heading } from '@abyss/web/ui/Heading';
import { ContentWidthWrapper } from '@pass-frontend/abyss/common/components/content-width-wrapper/ui';
import { MEDIA_QUERY } from '@pass-frontend/abyss/utility/style-helpers';
import { useIntl } from '@pass-frontend/common/i18n';
import { env } from '@pass-frontend/features/configuration/util';
import { GymPartnersDataProps } from '@pass-frontend/features/standalone/data-access';

const { FF_SUPPRESS_PREMIUM_ELITE_TIERS_GYMS } = env();

const CSS_BOX = {
  padding: '$lg 0',

  [MEDIA_QUERY.desktop]: {
    padding: '64px 0',
  },
};

const StyledImageSection = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, auto)',
  gridGap: '$lg',
  alignItems: 'center',
  justifyContent: 'center',

  '@screen >= $md': {
    gridTemplateColumns: 'repeat(3, auto)',
  },

  [MEDIA_QUERY.desktop]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const StyledHeading = styled(Heading, {
  marginBottom: '32px',

  [MEDIA_QUERY.desktop]: {
    marginBottom: '40px',
  },
});

const StyledImage = styled('img', {
  width: '150px',

  variants: {
    small: {
      true: {
        width: '84px',
        height: '100px',
      },
    },
  },

  [MEDIA_QUERY.mobileAndTablet]: {
    width: '100px',
  },
});

export function GymPartners(props: GymPartnersDataProps) {
  const { titleKey, images } = props;
  const { t } = useIntl();

  const filteredImages = images.filter(({ altTextKey }) => {
    return FF_SUPPRESS_PREMIUM_ELITE_TIERS_GYMS
      ? !altTextKey.toLowerCase().includes('orangetheory')
      : !altTextKey.toLowerCase().includes('workoutanytime');
  });

  return (
    <Box color="$gray1" css={CSS_BOX}>
      <ContentWidthWrapper>
        <StyledHeading offset={1} textAlign="center">
          {t(titleKey)}
        </StyledHeading>
        <StyledImageSection>
          {filteredImages.map(({ url, altTextKey }, key) => (
            <div data-testid="gymPartnerImage" key={key}>
              <StyledImage src={url} alt={t(altTextKey)} small={key === 3} />
            </div>
          ))}
        </StyledImageSection>
      </ContentWidthWrapper>
    </Box>
  );
}
